import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from './api.service';

export type ToolAppKey = 'motortwin' | 'fmeda';

export interface OrgAppAccess {
    motortwin: boolean;
    fmeda: boolean;
    materials: boolean;
}

@Injectable()
export class OrganisationService {
    private org$ = new BehaviorSubject<any>({});
    currentOrg$ = this.org$.asObservable();
    private activeApp$ = new BehaviorSubject<ToolAppKey | null>(null);
    currentApp$ = this.activeApp$.asObservable();

    constructor(private api: ApiService) { }

    setOrg(org: any) {
        this.org$.next(org);
    }

    setActiveApp(app: ToolAppKey | null) {
        this.activeApp$.next(app);
    }

    getCurrentOrg(): any {
        return this.org$.value;
    }

    getDefaultAppAccess(): OrgAppAccess {
        return {
            motortwin: true,
            fmeda: true,
            materials: true,
        };
    }

    getOrgAppAccess(org: any): OrgAppAccess {
        const defaultAccess = this.getDefaultAppAccess();
        const rawAccess = org && org.app_access;
        if (!rawAccess) {
            return defaultAccess;
        }

        return {
            motortwin: rawAccess.motortwin !== false,
            fmeda: rawAccess.fmeda !== false,
            materials: rawAccess.materials !== false,
        };
    }

    getCurrentOrgAppAccess(): OrgAppAccess {
        return this.getOrgAppAccess(this.getCurrentOrg());
    }

    isAppEnabledForCurrentOrg(app: ToolAppKey): boolean {
        return this.getCurrentOrgAppAccess()[app];
    }

    setOrgAppAccess(orgId: string, access: OrgAppAccess): Observable<OrgAppAccess> {
        if (!orgId) {
            return of(this.getDefaultAppAccess());
        }

        const appAccess = {
            motortwin: access.motortwin !== false,
            fmeda: access.fmeda !== false,
            materials: access.materials !== false,
        };
        return this.api.putOrganisationsIdAppAccess$(orgId, appAccess).pipe(
            tap(savedAccess => {
                const org = this.getCurrentOrg();
                if (org && org.id === orgId) {
                    org.app_access = savedAccess;
                    this.setOrg(org);
                }
            })
        );
    }
}